import React, { useEffect, useState } from "react"
import useViewport from "@/hooks/useViewport"
import { isImgUrlValid } from "@/services/ImageUrlValid"
import {
  getPersonaPriceDetails,
  getProductCartQuantity,
} from "@/components/PartsViewer/v2/helper.js"
import GridCardLoading from "@/components/PartsViewer/v2/GridAndListPanel/GridView/LoadingGrid"
import CONSTANTS from "@/constants/index"
import swatchMissing from "@/public/images/swatch-missing.jpeg"
import commingSoon from "@/public/scout_icon/coming-soon.jpg"
import { selectCartState } from "@/store/features/cartSlice"
import { useSelector } from "react-redux"
import CartButton from "@/components/PartsViewer/v2/CartButton/Index"
import { sortedVal } from "@/components/PartsViewer/v2/GridAndListPanel/utils"
import PropTypes from "prop-types"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import { isCanadaSite } from "@/utils/helper"

const GridView = props => {
  const {
    dataPromise,
    showPopup,
    isListExtend,
    dataInput,
    showCart,
    setShowCart,
    showCartPopUp,
    siteName,
  } = props || {}

  const [validUrl, setValidUrl] = useState({ status: "loading" })
  const [loading, setLoading] = useState("notStarted")
  const [productSwatche, setProductSwatche] = useState({})
  const [colour, setColour] = useState()
  const [selectedVariant, setSelectedVariant] = useState(null)
  const [colorItem, setColorItem] = useState(null)
  const [swatches, setSwatches] = useState(null)
  const [showProduct, setShowProduct] = useState(true)
  const device = useViewport()
  const { t } = useTranslation("common")

  const {
    Name: name,
    productName,
    productId,
    imageUrl: image,
    priceInfo,
    productInventoryInfo,
    isAddedFlag,
    cartQuantity,
  } = productSwatche
  const personaPriceList = getPersonaPriceDetails(dataInput)
  const { cart } = useSelector(selectCartState)
  const { outOfStockText, discontinuedText, replacesText } = getTranslations(t)
  const kohlerCanadaFlag = isCanadaSite(siteName)

  useEffect(() => {
    getGridItems()
    return () => {
      setProductSwatche({})
      setLoading("loading")
    }
  }, [cart])

  useEffect(() => {
    updateImageUrl()
    return () => {
      setValidUrl({})
    }
  }, [productSwatche?.imageUrl])

  const updateImageUrl = async () => {
    if (productSwatche?.imageUrl) {
      const res = await isImgUrlValid(productSwatche?.imageUrl)
      if (res) {
        setValidUrl({ status: "success" })
      } else {
        setValidUrl({ status: "failed" })
      }
    } else {
      setValidUrl({ status: "failed" })
    }
  }

  const getGridItems = async () => {
    setLoading("loading")
    const res = await dataPromise
    if (res?.data) {
      const {
        Name,
        productId,
        skuId,
        data,
        productIdKey,
        data: list,
        activeItem,
      } = res
      const imageUrl = data?.colorData?.[0]?.imgUrl
      const productName = data?.productName_s || Name
      const priceInfo = list?.colorData?.filter(
        item => item.id === activeItem
      )?.[0]
      const productInventoryInfo = list?.varientDetails?.filter(
        item => item.sku === activeItem
      )?.[0]
      const isAddedOne = getProductCartQuantity(
        list["Color.SKU.Details_ss"],
        cart,
        productId,
        skuId,
        activeItem
      )
      const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : ""
      const isAddedFlag = isAddedOne?.isAddedFlag
      setProductSwatche({
        Name,
        productName,
        productId,
        skuId,
        imageUrl,
        productIdKey,
        priceInfo,
        productInventoryInfo,
        isAddedFlag,
        cartQuantity,
      })
      if (list) {
        const getSwatches = list["varientDetails"]
        const filterSwatch = getSwatches?.filter(
          val => val["swatch"] !== "swatch_NA"
        )
        const colorArray = personaPriceList.map(item => {
          const matchItem = Object.values(filterSwatch).find(
            element => item.sku === element.sku
          )
          if (matchItem) return { ...item, ...matchItem }
          else return item
        })
        const sortArrayVal = sortedVal(colorArray)
        setColour(sortArrayVal)
        const activeItems = sortArrayVal?.filter(v =>
          v?.swatch ? v?.swatch !== "swatch_NA" : v[0]
        )
        const firstItems = activeItems[0]
        setColorItem(firstItems)
        setSelectedVariant(firstItems)
        setSwatches(getSwatches)
      }
      setLoading("loaded")
    } else {
      setLoading("loaded")
      setShowProduct(false)
    }
  }

  if (showProduct && loading !== "loaded")
    return <GridCardLoading isListExtend={isListExtend} />
  const colorSwatchDefaultImg = e => {
    e.target.src = swatchMissing.src
  }
  const colorCount =
    isListExtend && (device?.isLargeScreen || device?.isExtraLargeScreen)
      ? 7
      : 5
  let extraColor
  if (colour?.length > colorCount) {
    extraColor = colour?.length - colorCount
  }
  let marginStyle = ""
  if (colour?.length > 0) {
    marginStyle = "mb-8"
  }

  const varientPrices = selectedVariant ? selectedVariant : priceInfo
  const chkDiscontinue = selectedVariant
    ? selectedVariant?.discontinued
    : productInventoryInfo?.discontinued

  const outOfStock = selectedVariant
    ? !selectedVariant?.discontinued && selectedVariant?.isStock === "false"
    : productInventoryInfo?.isStock === "false" &&
      productInventoryInfo?.discontinued === false

  const handlerButton = arg => {
    if (arg) {
      setShowCart(!showCart)
      showCartPopUp(productId)
    }
  }
  const replaceSku = dataInput?.partApi?.replaceRootSku
  if (!showProduct) return null
  return (
    <div className="card">
      <div
        onClick={() => {
          showPopup(productId)
        }}
        data-testid="grid-card"
        onKeyDown={() => {
          showPopup(productId)
        }}
        className={`thumb-size ${isListExtend ? "grid-fullwidth" : ""}`}
      >
        {validUrl?.status === "loading" ? (
          <div className="loading-spinner border-0">
            <div className="shimmer-loading__image shimmer"></div>
          </div>
        ) : (
          <img
            className="card-img-top"
            src={validUrl.status === "success" ? image : commingSoon.src}
            alt={name}
          />
        )}
      </div>

      <div className={`card-bodys grid ${colour?.length <= 0 ? "mt-3" : ""}`}>
        <div
          className="product-information"
          onClick={() => {
            showPopup(productId)
          }}
          onKeyDown={() => {
            showPopup(productId)
          }}
        >
          <div className={`color-variants ${marginStyle}`}>
            {colour?.slice(0, colorCount)?.map(item =>
              item["swatch"] !== undefined ? (
                <label
                  key={item["swatch"]}
                  className="other_color"
                  onMouseEnter={() => setSelectedVariant(item)}
                  onMouseLeave={() => setSelectedVariant(colorItem)}
                >
                  <img
                    width="20px"
                    height="20px"
                    className="img_variant_color"
                    src={CONSTANTS.COLOR_FILE_URL + item["swatch"]}
                    alt={item["name"]}
                    onError={e => colorSwatchDefaultImg(e)}
                    title={selectedVariant ? selectedVariant[0] : item["name"]}
                  />
                </label>
              ) : null
            )}
            {extraColor ? (
              <label className="extra-color">+{extraColor}</label>
            ) : null}
          </div>

          {chkDiscontinue ? (
            <p
              className={`fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued`}
            >
              {discontinuedText}
            </p>
          ) : null}

          {outOfStock && !kohlerCanadaFlag ? (
            <p
              className={`fs-13 fw-600 tag-discontinue mb-5 outof-stoke label-discontinued `}
            >
              {outOfStockText}
            </p>
          ) : null}

          <div className="card-model">
            <p className="card-text fw-400 model-number card-product-title text-capitalize mb-5">
              {productName ?? name?.toLowerCase()}
            </p>
            <p
              className={`card-text fw-400 text-capitalize sku_product-description mb-5 ${
                device.isSmallScreen ? "my-1" : ""
              }`}
            >
              {varientPrices
                ? varientPrices?.customerSku || dataInput?.partApi?.skuId
                : varientPrices?.value || dataInput?.partApi?.skuId}
              {replaceSku ? (
                <span className="replaceVal">
                  ({replacesText} {replaceSku})
                </span>
              ) : null}
            </p>
            <p className={`card-text fw-400 text-capitalize sku-price`}>
              {varientPrices?.discountedPrice
                ? varientPrices?.currencySign + varientPrices?.discountedPrice
                : null}
              <span
                className={`sku-price ${
                  varientPrices?.discountedPrice ? "mx-1 discount-price" : ""
                }`}
              >
                {varientPrices?.currencySign + varientPrices?.price || null}
              </span>
            </p>
          </div>
        </div>
        {!kohlerCanadaFlag ? (
          <CartButton
            isAddedFlag={isAddedFlag}
            cartQuantity={cartQuantity}
            handlerButton={handlerButton}
            swatches={swatches}
          />
        ) : null}
      </div>
    </div>
  )
}

GridView.propTypes = {
  showPopup: PropTypes.bool.isRequired,
  dataPromise: PropTypes.func.isRequired,
  isListExtend: PropTypes.bool.isRequired,
  dataInput: PropTypes.object.isRequired,
  showCart: PropTypes.bool.isRequired,
  setShowCart: PropTypes.func.isRequired,
  showCartPopUp: PropTypes.func.isRequired,
  siteName: PropTypes.string.isRequired,
}

export default GridView
